import "../../Css/Common/Skeletons.css";
import "../../Css/Common/ContentSkeleton.css";

export const ContentSkeleton = () => {
  return (
    <div className="contentSkeleton">
      <div className="contentSkeleton_toolbar">
        <span className="c-skeleton-line contentSkeleton_toolbarItem" />
        <span className="c-skeleton-line contentSkeleton_toolbarItem contentSkeleton_toolbarItem--short" />
      </div>
      <div className="contentSkeleton_body">
        <span className="c-skeleton-line contentSkeleton_row" />
        <span className="c-skeleton-line contentSkeleton_row" />
        <span className="c-skeleton-line contentSkeleton_row contentSkeleton_row--short" />
      </div>
    </div>
  );
};
